export const countries = {
  BR: {
    name: 'Brasil',
    language: 'pt',
    currency: {
      code: 'BRL',
      symbol: 'R$',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 87.00,
          discounted: 47.00,
          total: 564.00
        },
        semiannual: {
          original: 117.00,
          discounted: 67.00,
          total: 402.00
        },
        monthly: {
          original: 149.00,
          discounted: 87.00,
          total: 87.00
        }
      },
      team: {
        annual: {
          original: 119.90,
          discounted: 67.00,
          total: 804.00
        },
        semiannual: {
          original: 159.90,
          discounted: 87.00,
          total: 522.00
        },
        monthly: {
          original: 197.00,
          discounted: 107.00,
          total: 107.00
        }
      }
    },
    documents: {
      individual: {
        name: 'CPF',
        mask: '999.999.999-99',
        length: 11,
        validation: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
      },
      company: {
        name: 'CNPJ',
        mask: '99.999.999/9999-99',
        length: 14,
        validation: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
      }
    },
    phone: {
      mask: '(99) 99999-9999',
      length: 11,
      validation: /^\(\d{2}\) \d{5}-\d{4}$/
    },
    address: {
      zipCode: {
        mask: '99999-999',
        length: 8,
        validation: /^\d{5}-\d{3}$/
      },
      state: {
        type: 'select',
        options: [
          'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
        ]
      }
    }
  },
  PT: {
    name: 'Portugal',
    language: 'pt',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'NIF',
        mask: '999999999',
        length: 9,
        validation: /^\d{9}$/
      },
      company: {
        name: 'NIF',
        mask: '999999999',
        length: 9,
        validation: /^\d{9}$/
      }
    },
    phone: {
      mask: '999 999 999',
      length: 9,
      validation: /^\d{9}$/
    },
    address: {
      zipCode: {
        mask: '9999-999',
        length: 7,
        validation: /^\d{4}-\d{3}$/
      },
      state: {
        type: 'select',
        options: [
          'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco', 'Coimbra', 'Évora', 'Faro', 'Guarda', 'Leiria', 'Lisboa', 'Portalegre', 'Porto', 'Santarém', 'Setúbal', 'Viana do Castelo', 'Vila Real', 'Viseu', 'Açores', 'Madeira'
        ]
      }
    }
  },
  US: {
    name: 'Estados Unidos',
    language: 'en',
    currency: {
      code: 'USD',
      symbol: '$',
      decimalSeparator: '.',
      thousandSeparator: ',',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'SSN',
        mask: '999-99-9999',
        length: 9,
        validation: /^\d{3}-\d{2}-\d{4}$/
      },
      company: {
        name: 'EIN',
        mask: '99-9999999',
        length: 9,
        validation: /^\d{2}-\d{7}$/
      }
    },
    phone: {
      mask: '(999) 999-9999',
      length: 10,
      validation: /^\(\d{3}\) \d{3}-\d{4}$/
    },
    address: {
      zipCode: {
        mask: '99999-9999',
        length: 9,
        validation: /^\d{5}-\d{4}$/
      },
      state: {
        type: 'select',
        options: [
          'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
        ]
      }
    }
  },
  GB: {
    name: 'Reino Unido',
    language: 'en',
    currency: {
      code: 'GBP',
      symbol: '£',
      decimalSeparator: '.',
      thousandSeparator: ',',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'NIN',
        mask: 'AA 99 99 99 A',
        length: 9,
        validation: /^[A-Z]{2} \d{2} \d{2} \d{2} [A-Z]$/
      },
      company: {
        name: 'VAT',
        mask: 'GB999 9999 99',
        length: 12,
        validation: /^GB\d{3} \d{4} \d{2}$/
      }
    },
    phone: {
      mask: '99999 999999',
      length: 11,
      validation: /^\d{5} \d{6}$/
    },
    address: {
      zipCode: {
        mask: 'AA9A 9AA',
        length: 7,
        validation: /^[A-Z]{2}\d[A-Z] \d[A-Z]{2}$/
      },
      state: {
        type: 'select',
        options: [
          'England', 'Scotland', 'Wales', 'Northern Ireland'
        ]
      }
    }
  },
  FR: {
    name: 'França',
    language: 'fr',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: ' ',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'NIR',
        mask: '1 99 99 99 999 999 99',
        length: 15,
        validation: /^1 \d{2} \d{2} \d{2} \d{3} \d{3} \d{2}$/
      },
      company: {
        name: 'SIRET',
        mask: '999 999 999 00099',
        length: 14,
        validation: /^\d{3} \d{3} \d{3} \d{5}$/
      }
    },
    phone: {
      mask: '99 99 99 99 99',
      length: 10,
      validation: /^\d{2} \d{2} \d{2} \d{2} \d{2}$/
    },
    address: {
      zipCode: {
        mask: '99999',
        length: 5,
        validation: /^\d{5}$/
      },
      state: {
        type: 'select',
        options: [
          'Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Bretagne', 'Centre-Val de Loire', 'Corse', 'Grand Est', 'Hauts-de-France', 'Île-de-France', 'Normandie', 'Nouvelle-Aquitaine', 'Occitanie', 'Pays de la Loire', 'Provence-Alpes-Côte d\'Azur'
        ]
      }
    }
  },
  IT: {
    name: 'Itália',
    language: 'it',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'Codice Fiscale',
        mask: 'AAAAAA99A99A999A',
        length: 16,
        validation: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/
      },
      company: {
        name: 'Partita IVA',
        mask: '99999999999',
        length: 11,
        validation: /^\d{11}$/
      }
    },
    phone: {
      mask: '999 999 9999',
      length: 10,
      validation: /^\d{3} \d{3} \d{4}$/
    },
    address: {
      zipCode: {
        mask: '99999',
        length: 5,
        validation: /^\d{5}$/
      },
      state: {
        type: 'select',
        options: [
          'Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Friuli Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino-Alto Adige', 'Umbria', 'Valle d\'Aosta', 'Veneto'
        ]
      }
    }
  },
  ES: {
    name: 'Espanha',
    language: 'es',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'DNI',
        mask: '99999999A',
        length: 9,
        validation: /^\d{8}[A-Z]$/
      },
      company: {
        name: 'NIF',
        mask: 'A99999999',
        length: 9,
        validation: /^[A-Z]\d{8}$/
      }
    },
    phone: {
      mask: '999 999 999',
      length: 9,
      validation: /^\d{3} \d{3} \d{3}$/
    },
    address: {
      zipCode: {
        mask: '99999',
        length: 5,
        validation: /^\d{5}$/
      },
      state: {
        type: 'select',
        options: [
          'Andalucía', 'Aragón', 'Asturias', 'Baleares', 'Canarias', 'Cantabria', 'Castilla-La Mancha', 'Castilla y León', 'Cataluña', 'Comunidad Valenciana', 'Extremadura', 'Galicia', 'Madrid', 'Murcia', 'Navarra', 'País Vasco', 'La Rioja', 'Ceuta', 'Melilla'
        ]
      }
    }
  },
  DE: {
    name: 'Alemanha',
    language: 'de',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'Steuer-ID',
        mask: '99 999 999 999',
        length: 11,
        validation: /^\d{2} \d{3} \d{3} \d{3}$/
      },
      company: {
        name: 'USt-IdNr.',
        mask: 'DE999999999',
        length: 11,
        validation: /^DE\d{9}$/
      }
    },
    phone: {
      mask: '9999 9999999',
      length: 11,
      validation: /^\d{4} \d{7}$/
    },
    address: {
      zipCode: {
        mask: '99999',
        length: 5,
        validation: /^\d{5}$/
      },
      state: {
        type: 'select',
        options: [
          'Baden-Württemberg', 'Bayern', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hessen', 'Mecklenburg-Vorpommern', 'Niedersachsen', 'Nordrhein-Westfalen', 'Rheinland-Pfalz', 'Saarland', 'Sachsen', 'Sachsen-Anhalt', 'Schleswig-Holstein', 'Thüringen'
        ]
      }
    }
  },
  NL: {
    name: 'Holanda',
    language: 'nl',
    currency: {
      code: 'EUR',
      symbol: '€',
      decimalSeparator: ',',
      thousandSeparator: '.',
      decimalPlaces: 2
    },
    plans: {
      individual: {
        annual: {
          original: 17.00,
          discounted: 9.00,
          total: 108.00
        },
        semiannual: {
          original: 22.00,
          discounted: 12.00,
          total: 72.00
        },
        monthly: {
          original: 27.00,
          discounted: 17.00,
          total: 17.00
        }
      },
      team: {
        annual: {
          original: 19.00,
          discounted: 11.00,
          total: 132.00
        },
        semiannual: {
          original: 23.00,
          discounted: 15.00,
          total: 90.00
        },
        monthly: {
          original: 29.00,
          discounted: 19.00,
          total: 19.00
        }
      }
    },
    documents: {
      individual: {
        name: 'BSN',
        mask: '999999999',
        length: 9,
        validation: /^\d{9}$/
      },
      company: {
        name: 'KVK',
        mask: '99999999',
        length: 8,
        validation: /^\d{8}$/
      }
    },
    phone: {
      mask: '999 999 9999',
      length: 10,
      validation: /^\d{3} \d{3} \d{4}$/
    },
    address: {
      zipCode: {
        mask: '9999 AA',
        length: 6,
        validation: /^\d{4} [A-Z]{2}$/
      },
      state: {
        type: 'select',
        options: [
          'Drenthe', 'Flevoland', 'Friesland', 'Gelderland', 'Groningen', 'Limburg', 'Noord-Brabant', 'Noord-Holland', 'Overijssel', 'Utrecht', 'Zeeland', 'Zuid-Holland'
        ]
      }
    }
  }
};

export const getCountryConfig = (countryCode) => {
  return countries[countryCode] || countries.BR; // Retorna configuração do Brasil como padrão
};

export const formatCurrency = (value, countryCode) => {
  const config = getCountryConfig(countryCode);
  const { symbol, decimalSeparator, thousandSeparator, decimalPlaces } = config.currency;
  
  return `${value.toFixed(decimalPlaces)
    .replace('.', decimalSeparator)
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)}`;
};

export const formatDocument = (value, countryCode, type = 'individual') => {
  const config = getCountryConfig(countryCode);
  const docConfig = config.documents[type];
  
  if (!docConfig) return value;
  
  const mask = docConfig.mask;
  let result = '';
  let valueIndex = 0;
  
  for (let i = 0; i < mask.length; i++) {
    if (valueIndex >= value.length) break;
    
    if (mask[i] === '9') {
      result += value[valueIndex++];
    } else if (mask[i] === 'A') {
      result += value[valueIndex++].toUpperCase();
    } else {
      result += mask[i];
    }
  }
  
  return result;
};

export const formatPhone = (value, countryCode) => {
  const config = getCountryConfig(countryCode);
  const mask = config.phone.mask;
  let result = '';
  let valueIndex = 0;
  
  for (let i = 0; i < mask.length; i++) {
    if (valueIndex >= value.length) break;
    
    if (mask[i] === '9') {
      result += value[valueIndex++];
    } else {
      result += mask[i];
    }
  }
  
  return result;
};

export const formatZipCode = (value, countryCode) => {
  const config = getCountryConfig(countryCode);
  const mask = config.address.zipCode.mask;
  let result = '';
  let valueIndex = 0;
  
  for (let i = 0; i < mask.length; i++) {
    if (valueIndex >= value.length) break;
    
    if (mask[i] === '9') {
      result += value[valueIndex++];
    } else if (mask[i] === 'A') {
      result += value[valueIndex++].toUpperCase();
    } else {
      result += mask[i];
    }
  }
  
  return result;
}; 